export const LOGGED_IN = 'loggedIn'

export function changeLoginState(loggedIn) {
    return { type: LOGGED_IN, loggedIn: loggedIn }
}
